import { defineMessages } from 'react-intl';
import { getIntl } from '../lang/util/GlobalIntlProvider';

export const messages = defineMessages({
  addCustomTagPlaceholder: {
    defaultMessage: 'Add Custom Label',
    description: 'CTA for adding a custom label',
  },
  createCustomTagPlaceholder: {
    defaultMessage: 'Create Custom Label',
    description: 'Placeholder for creating custom labels',
  },
  fontUnavailablePlaceholder: {
    defaultMessage: '(Not Available)',
    description: 'Text shown when the selected font is no longer available',
  },
  placeholderText: {
    defaultMessage: 'Text Placeholder',
    description: 'Default text used on new text layers',
  },
  processingMedia: {
    defaultMessage: 'Processing Media…',
    description: 'Label shown when media is being processed',
  },
  uploadStatus: {
    defaultMessage: '{uploadPercent, number, percent} Uploaded',
    description: 'Label showing the current upload progress',
  },
});
// TODO(tleonard): properly translate the placeholder and status messages without breaking the site
const placeholderText = messages.placeholderText;
export const getPlaceholderText = () => {
  const intl = getIntl();
  return intl
    ? intl.formatMessage(placeholderText)
    : placeholderText.defaultMessage;
};

const processingMedia = messages.processingMedia;
export const getProcessingMedia = () => {
  const intl = getIntl();
  return intl
    ? intl.formatMessage(processingMedia)
    : processingMedia.defaultMessage;
};

const uploadStatus = messages.uploadStatus;
export const getUploadStatus = (percent) => {
  const intl = getIntl();
  return intl
    ? intl.formatMessage(uploadStatus, { uploadPercent: percent })
    : `${percent}%`;
};

const fontUnavailablePlaceholder = messages.fontUnavailablePlaceholder;
export const getFontUnavailablePlaceholder = () => {
  return fontUnavailablePlaceholder;
};

const createCustomTagPlaceholder = messages.createCustomTagPlaceholder;
export const getCreateCustomTagPlaceholder = () => {
  return createCustomTagPlaceholder;
};

const addCustomTagPlaceholder = messages.addCustomTagPlaceholder;
export const getAddCustomTagPlaceholder = () => {
  return addCustomTagPlaceholder;
};
